<template>
  <div class="lp_carousel">
    <div v-if="images.length">
      <carousel ref="carouselSelector" v-if="images.length" :pagination-enabled="false" :paginationPadding="15"
        :paginationSize="15" :loop="images.length > 0 ? true : false" :autoplay="images.length > 0 ? true : false"
        :autoplay-timeout="6000" :perPageCustom="[
          [352, 1],
          [425, 2],
          [768, 3],
          [1024, 4],
        ]">
        <slide v-for="(item, index) in images" :key="index">
          <div :style="`background-image: url(${item.image});`" class="banner" @click="openViewer(index)"></div>
        </slide>
      </carousel>
      <div class="images_news_gallery" v-viewer="{movable: false}" style="display: none">
        <img v-for="(item, index) in images" :key="index" :src="item.image" alt="Imagem da galeria" />
      </div>
    </div>
  </div>
</template>
<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import {Carousel, Slide} from "vue-carousel";
Vue.use(Viewer, {
  defaultOptions: {
    title: false,
    rotatable: false,
    scalable: false,
  },
});
export default {
  props: ["images"],
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.$refs.carouselSelector.goToPage(index);
    },
    advancePages(direction) {
      this.$refs.carouselSelector.advancePage(direction);
    },
    openViewer(id) {
      const viewer = this.$el.querySelector(".images_news_gallery").$viewer;
      viewer.view(id);
      viewer.show();
    },
  },
  created() { },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/website/_variables.scss";

.banner {
  height: 270px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 15px;
}

.lp_carousel {
  margin-bottom: 110px;

  @media screen and (max-width: 768px) {
    margin-bottom: 50px;
  }
}
</style>